module.exports = __webpack_public_path__ + "static/media/spices.cd54f76f.webp";